// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-3b7da860] .v-timeline--dense:not(.v-timeline--reverse):before {\n  left: calc(36px - 1px);\n}\n[data-v-3b7da860] .v-timeline--dense .v-timeline-item__body {\n  max-width: calc(100% - 60px);\n}\n[data-v-3b7da860] .v-timeline-item__divider {\n  min-width: 48px;\n}", ""]);
// Exports
module.exports = exports;
